import { render, staticRenderFns } from "./AdminIdeaSelectModalContent.vue?vue&type=template&id=40fe6a4a&scoped=true&"
import script from "./AdminIdeaSelectModalContent.vue?vue&type=script&lang=ts&"
export * from "./AdminIdeaSelectModalContent.vue?vue&type=script&lang=ts&"
import style0 from "./AdminIdeaSelectModalContent.vue?vue&type=style&index=0&id=40fe6a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fe6a4a",
  null
  
)

export default component.exports